<template>
    <div class="tabTests-wrapper">
        <div class="tests" v-if="currentTab == 1">
            <h2 class="heading" v-if="testsInProgress.length">В прогрессе</h2>
            <div class="row">
                <TestInProgressItem
                    v-for="(test, i) in testsInProgress"
                    :key="i"
                    :test="test"
                ></TestInProgressItem>
            </div>
            <h2 class="heading" v-if="testsCompleted.length">
                Завершенные тесты
            </h2>
            <div
                class="row"
                v-if="completedTests.length || projectory_achived_tests.length"
            >
                <TestCompletedCard
                    v-for="test in completedTests"
                    :key="test.id"
                    class="completed-card"
                    :test="test"
                    @on-show-result="switchResultPop(true, $event)"
                />
                <ProjectoryTestCompletedItem
                    v-for="(test, i) in projectory_achived_tests"
                    :key="i"
                    :test="test"
                ></ProjectoryTestCompletedItem>
            </div>
            <div v-else class="empty">
                <div class="no-tests-card shadow">Вы еще не прошли ни один тест</div>
            </div>
            <Dialog :padding="false" v-model="showResultsPop">
                <TestResultsCard
                    :test="activeTest"
                    @confirm="switchResultPop(false)"
                />
            </Dialog>
        </div>
    </div>
</template>

<script>
import TestInProgressItem from './tab-tests/TestInProgressItem';
import TestCompletedCard from './tab-tests/TestCompletedCard';
import ProjectoryTestCompletedItem from './tab-tests/ProjectoryTestCompletedItem';
import TestResultsCard from './tab-tests/TestResultsCard';
import Dialog from './../../UI/Dialog';

import { mapGetters, mapActions } from 'vuex';

const actions = ['loadProjectoryAchivedTests'];
const examinationActions = ['loadSessions'];
const getters = [
    'recommendedTests',
    'testsCompleted',
    'testsInProgress',
    'projectory_achived_tests',
];
const examinationGetters = ['getLastSessionsByStatuses'];

export default {
    name: 'TabTests',

    components: {
        TestInProgressItem,
        TestCompletedCard,
        ProjectoryTestCompletedItem,
        Dialog,
        TestResultsCard,
    },

    data: () => ({
        tabs: [
            {
                label: 'Рекомендуемые',
                type: 'recommendedTests',
            },
            {
                label: 'Пройденные',
                type: 'myTests',
            },
        ],
        currentTab: 1,
        activeTest: null,
        showResultsPop: false,
    }),

    computed: {
        ...mapGetters(getters),
        ...mapGetters('newExamination', examinationGetters),

        completedTests() {
            return this.getLastSessionsByStatuses(['completed', 'in_check']) || [];
        },
    },

    methods: {
        ...mapActions(actions),
        ...mapActions('newExamination', examinationActions),

        tabClicked(index) {
            this.currentTab = index;
        },

        switchResultPop(flag, test = null) {
            this.activeTest = test;
            this.showResultsPop = flag;
        },

        getParams() {
            return {
                limit: 1000,
                offset: 0,
                'filter[foreignTypes]': ['test'],
            };
        },
    },

    async mounted() {
        await Promise.all([
            this.loadSessions(this.getParams()),
            this.loadProjectoryAchivedTests(),
        ]);
    },
};
</script>

<style scoped lang="scss">
@import '~@/styles/rem';
@import '~@/styles/mrem';

.tabs {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-radius: 4px;
    margin-bottom: 1rem;
    background: white;
    color: #4663AB;
    border: rem(1) solid #4663AB;

    .tab {
        width: 50%;
        text-align: center;
        height: rem(42);
        line-height: rem(42);
        cursor: pointer;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: rem(14);
    }
    .active {
        background: #4663AB;
        color: white;
    }
}

.row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;

    @include on-mobile {
        padding: 0 mrem(16);
    }
}

.empty {
    width: 100%;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: flex-start;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    color: #98a0a9;
    font-size: 0.9rem;

    @include on-mobile {
        height: auto;
        margin: 0 mrem(16);
        font-size: mrem(14);
        line-height: mrem(17);
        font-weight: 500;
    }
}

.heading {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: rem(21);
    line-height: rem(26);
    color: #4663AB;

    @include on-mobile {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: mrem(16);
        line-height: mrem(20);
        color: #4663AB;
        margin: mrem(20) mrem(16) mrem(16) mrem(16);
    }
}

.completed-card {
    width: 48.7%;
    min-height: rem(202);
    margin: 0 0 rem(20) 0;


    @include on-mobile {
        width: 100%;
        min-height: auto;
        margin: 0 0 mrem(12) 0;
    }
}

.no-tests-card {
    background-color: #ffffff;
    border-radius: 0.2rem;
    padding: rem(32);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    min-width: rem(770);

    @include on-mobile {
        width: 100%;
    }
}
</style>
